type UpdateChangedQuestionsListParams = {
  currentChangedQuestions: string[];
  newQuestionNames: string[];
};

type UpdateChangedQuestionsListResult = {
  updatedChangedQuestions: string[];
  filteredQuestionNames: string[];
};

/**
 * Updates the changed questions list by removing items below the first new question
 * and appending the new question names.
 *
 * Also returns the filtered question names (questions before the first new question)
 * for use in filtering existing questions in the section.
 */
export const updateChangedQuestionsList = ({
  currentChangedQuestions,
  newQuestionNames,
}: UpdateChangedQuestionsListParams): UpdateChangedQuestionsListResult => {
  // Handle edge case: empty new questions array
  if (newQuestionNames.length === 0) {
    return {
      updatedChangedQuestions: currentChangedQuestions,
      filteredQuestionNames: currentChangedQuestions,
    };
  }

  const firstNewQuestionName = newQuestionNames[0];
  const firstIndex = currentChangedQuestions.indexOf(firstNewQuestionName);

  // Keep only questions before the first new question
  const filteredQuestions = Array.from(
    new Set(
      firstIndex > -1
        ? currentChangedQuestions.slice(0, firstIndex)
        : currentChangedQuestions,
    ),
  );

  // Append the new questions to the changed list
  return {
    updatedChangedQuestions: [...filteredQuestions, ...newQuestionNames],
    filteredQuestionNames: filteredQuestions,
  };
};
